import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'redux/store';
import { TrainingManagerState } from './redux';

export const trainingFacilitySelector = (state: RootState) => state.trainingFacilities;
export const accountManagerStateSelector = createSelector(trainingFacilitySelector, (state: TrainingManagerState) => state);
export const paramsSelector = createSelector(trainingFacilitySelector, (state: TrainingManagerState) => state.params);
export const itemDataSelector = createSelector(trainingFacilitySelector, (state: TrainingManagerState) => state.itemData);
